import {Component, OnInit, ViewChild, HostListener, Output, EventEmitter} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentService } from 'src/app/_services/document.services';

import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';
import cloneDeep  from 'lodash/cloneDeep';



@Component({
  selector: 'app-dynamic-form',
  templateUrl: './fileinbox-dynamic-forms.component.html',
  styleUrls: ['./fileinbox-dynamic-forms.component.scss']
})
export class FileInboxDynamicForms implements OnInit {
  
  properties:any;
  valuesForm: FormGroup;
  values: any[];  

  @Output() formValue = new EventEmitter<any>();  
  @Output() isValidData = new EventEmitter<boolean>();

  constructor(   
    private virtualFolderService: FileInboxVirtualFolderService,
    private documentService: DocumentService,  
  ) {
    
  }

  ngOnInit() {
    this.virtualFolderService.getDynamicForms().subscribe(response => {
      this.properties = response;
    });
  }

  validateID(property, event) {
    this.formValue.emit(property);
    if (event && event.key && event.key == 'Enter') {      
      this.performValidation(property);
    }
  }

  performValidation(property){
    return new Promise((resolve, reject) => {
    
      var editField = property.value;
      if (editField && editField.trim() != "") {
          var operation = property.operation_name;
          var isValid = false;
          let Ids = [];
            if (editField) {
              editField = editField.trim();
              let list = editField.split(",");
              for (var index in list) {
                Ids.push(list[index]);
              }
            }
            var request = {
              "value": Ids,
              "key": operation
            }          
            this.documentService.validateMetadata(request).subscribe(resp => {
              if (resp) {            
                for (var i in Ids) {
                  if (resp[Ids[i]]) {
                    isValid = true;
                  } else {
                    isValid = false;        
                  }
                }
                if (!isValid) {
                  property["error"]["flag"] = true;
                } else {
                  property["error"]["flag"] = false;
                }
                this.isValidData.emit(isValid);
              } 
              resolve(isValid);           
            }, error => {
              console.log(error);
              reject(false);        
            });
        } else {
          property["error"] = {
            "flag": false,
            "message": ""
          }
          this.isValidData.emit(true);    
          resolve(true);
        }
      
      });
  }

}
